<template #title>
  <b-card no-body  style="padding:5px;margin-bottom:5px !important">
    <div class="m-1">
      <b-row>
        <b-col md="3">
          <v-select
            :options="listCampeonatos"
            placeholder="Selecciona Campeonato"
            :clearable="false"
            v-model="campeonatoSeleccionado"
            @input="getEstadisticas(campeonatoSeleccionado.value)"
          />
        </b-col>
      </b-row>

      <b-overlay :show="showLoading" rounded="sm">
        <div class="tabla-malla m-1" >
          <table class="table table-bordered table-sm mb-0">
            <thead>
              <tr>
                <th class="sticky-col encabezado-delegado">
                  Delegado
                </th>

                <th
                  v-for="reunion in reuniones"
                  :key="reunion.id_control_reunion_cabecera"
                  class="text-center sticky-header th-reunion"
                >
                  <div class="d-flex flex-column align-items-center">
                    <span class="fw-bold">
                      {{ reunion.fecha_reunion }}
                    </span>

                    <feather-icon
                      icon="InfoIcon"
                      size="16"
                      class="text-primary mt-1"
                      v-b-tooltip.hover
                      :title="reunion.tema"
                      style="cursor: pointer"
                    />
                  </div>
                </th>

                <th class="text-center sticky-header sticky-col-totales">
                  Totales: {{ reuniones.length }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="delegado in delegados"
                :key="delegado.id_historial_delegado"
              >
                <td class="sticky-col bg-white">
                  <div class="d-flex align-items-center">
                    <img
                      :src="delegado.url_foto_jug"
                      class="foto-jugador me-2"
                    />

                    <div>
                      <div class="fw-bold ml-1">
                        {{ delegado.nombre_corto }}
                      </div>

                      <small class="text-muted ml-1">
                        {{ delegado.equipo }}
                      </small>
                    </div>
                  </div>
                </td>

                <td
                  v-for="reunion in reuniones"
                  :key="reunion.id_control_reunion_cabecera"
                  class="text-center celda-asistencia"
                >
                  <feather-icon
                    :icon="
                      delegado.asistencias[reunion.id_control_reunion_cabecera]
                        ? delegado.asistencias[
                            reunion.id_control_reunion_cabecera
                          ].icon
                        : 'XCircleIcon'
                    "
                    size="16"
                    :class="
                      delegado.asistencias[reunion.id_control_reunion_cabecera]
                        ? delegado.asistencias[
                            reunion.id_control_reunion_cabecera
                          ].class
                        : 'text-secondary'
                    "
                  />
                </td>

                <td class="text-center sticky-col-totales">
                  <div class="d-flex flex-wrap justify-content-center gap-1">
                    <span
                      v-for="estado in estados"
                      :key="estado.id_estado_asistencia"
                      class="badge-total"
                      :class="estado.class"
                    >
                      {{ estado.abreviatura }}:
                      {{
                        delegado.totales[estado.estado_delegado.toUpperCase()]
                      }}
                    </span>

                    <span class="badge-total falta">
                      F: {{ delegado.totales.FALTA }}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </div>
  </b-card>
</template>
<script>
import vSelect from 'vue-select'
import {
  BCard,
  BRow,
  BCol,
  BOverlay,
  VBTooltip,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import { URL } from '../../utils/variables'

export default {
  components: {
    vSelect,
    BCard,
    BRow,
    BCol,
    BOverlay,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    listCampeonatos: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const campeonatoSeleccionado = ref(null)
    const showLoading = ref(false)
    const reuniones = ref([])
    const delegados = ref([])
    const estados = ref([])
    const { getApi } = apiCall()

    async function getEstadisticas(idCampeonato) {
      showLoading.value = true
      reuniones.value = []
      delegados.value = []
      const path = `ApiConfiguration/getMallaDelegadosAsistencia/${idCampeonato}`
      const data = await getApi(URL, path)
      reuniones.value = data.reuniones
      delegados.value = data.delegados
      estados.value = data.estados
      showLoading.value = false
    }

    const formatFecha = fecha => {
      const d = new Date(fecha)

      return d.toLocaleDateString('es-EC', {
        day: '2-digit',
        month: '2-digit',
      })
    }
    return {
      campeonatoSeleccionado,
      showLoading,
      getEstadisticas,
      reuniones,
      delegados,
      estados,
      formatFecha,
    }
  },
}
</script>
<style scoped>
.tabla-malla {
  max-height: 70vh;
  overflow: auto;
}

.sticky-header {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 20;
}

.sticky-col {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 10;
  min-width: 250px;
}

thead .sticky-col {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 30;
}

tbody .sticky-col {
  z-index: 10;
}

.sticky-col-totales {
  position: sticky;
  right: 0;
  background: #fff;
  z-index: 15;
  min-width: 210px;
}

thead .sticky-col-totales {
  z-index: 35;
}

.badge-total {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  padding: 2px 6px;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

.badge-total.asistencia {
  background: #e8f5e9;
  color: #2e7d32;
}

.badge-total.justificada {
  background: #e3f2fd;
  color: #1565c0;
}

.badge-total.atraso {
  background: #fff3e0;
  color: #ef6c00;
}

.badge-total.abandono {
  background: #ffebee;
  color: #c62828;
}

.foto-jugador {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
}

.celda-asistencia {
  min-width: 90px;
  cursor: pointer;
}
.tema-reunion {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
